<template>
  <div class="rightContent">
    <div class="table">
      <el-select v-model="cid" placeholder="请选择班级" @change="valChange">
          <el-option v-for="(item,index) in classArr" :key="index" :label="item.name" :value="item.cid">
          </el-option>
      </el-select>
      <button class="exportStudent" @click="_exportStudent()">导出数据</button>
      <el-table :data="tableData" border style="width: 990px">
        <el-table-column prop="uid" label="学生ID" width="80" align="center"></el-table-column>
        <el-table-column prop="realName" label="学生名" width="80" align="center"></el-table-column>
        <el-table-column label="身份证号" width="140" align="center">
          <template slot-scope="scope">{{scope.row.id.substring(0,6)}}***{{scope.row.id.slice(-4)}}</template>
        </el-table-column>
        <el-table-column label="手机号" width="90" align="center">
          <template
            slot-scope="scope"
          >{{scope.row.telephone.substring(0,3)}}***{{scope.row.telephone.substring(8,11)}}</template>
        </el-table-column>
        <el-table-column prop="cid" label="班级ID" width="80" align="center"></el-table-column>
        <el-table-column prop="className" label="班级名" width="80" align="center"></el-table-column>
        <el-table-column label="累计学 习时长" width="80" align="center">
          <template
            slot-scope="scope"
          >{{"00:00:00".slice(0,8-scope.row.totalLearnHour.length)+scope.row.totalLearnHour}}</template>
        </el-table-column>
        <el-table-column prop="totalCredit" label="累计学分" width="80" align="center"></el-table-column>
        <el-table-column label="详细课程学习情况" width="80" align="center">
          <template slot-scope="scope">
            <router-link
              :to="{name:'detail',params:{id:scope.row.uid+'&'+ scope.row.id.substring(0,6)+scope.row.id.slice(-4)+'&'+scope.row.realName}}"
              style="color:#109eff;"
            >点击查看</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="feedbackNum" label="学生提问" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.feedbackNum==0">N/A</span>
            <span v-else>{{scope.row.feedbackNum}}个提问</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="applyStaus"
          label="申请考试状态"
          width="119"
          align="center"
          :formatter="statusFun"
        ></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="10"
        prev-text="上一页"
        next-text="下一页"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { pageStudent, exportStudent } from "@/assets/js/axios.js";
export default {
  name: "tearcher",
  data() {
    return {
      page: 1,
      row: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      classArr:[],
      cid:0,
    };
  },
  created() {
    this._pageStudent();
  },
  methods: {
    valChange(val){
        this.cid=val;
        this._pageStudent();
    },
    handleSizeChange(val) {
      this.row = val;
      this._pageStudent();
    },
    handleCurrentChange(val) {
      this.page = val;
      this._pageStudent();
    },
    _pageStudent() {
      pageStudent(this.page, this.row, this.cid).then(res => {
        this.tableData = res.data;
        this.total = parseInt(res.msg);
        var arr=res.encrypt.split("&");
        this.classArr=[];
        for(let i=0;i<arr.length;i++){
            if(arr[i]){
                var obj=arr[i].split("=");
                this.classArr.push({cid:obj[0],name:obj[1]})
            }
        }
        if(this.cid==0&&this.classArr[0]){
            this.cid=this.classArr[0].cid
        }
      });
    },
    _exportStudent() {
      exportStudent(this.cid).then(res => {
        if (res.code == 1) {
          window.open("https://icpeixun.com" + res.data);
        } else {
          this.$message({
            message: "导出数据失败，请重试",
            type: "error"
          });
        }
      });
    },
    statusFun(row, column) {
      switch (row.applyStatus) {
        case 0:
          return "N/A";
        case 1:
          return "可以申请";
        case 2:
          return "已申请未批";
        case 3:
          return "已通过未答";
        case 4:
          return "已答";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.table {
  /deep/ .el-pagination {
    /deep/ .btn-prev,
    .btn-next {
      min-width: 50px;
    }
  }
  .el-select{
      margin-top:10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personal/tearcher.vue